import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import { useTranslation } from 'react-i18next';
import { BASE_API } from '../Config/Config';

const Services = () => {
  const { t } = useTranslation();

  const keyActivities = t('servicesKeyActivities', { returnObjects: true });
  const otherObjectives = t('servicesOtherObjectives', { returnObjects: true });
  const servicesOffered = t('servicesOffered', { returnObjects: true });
  const generalTermsColumns = t('servicesGeneralTermsColumns', { returnObjects: true });
  const tariffRows = t('servicesTariffRows', { returnObjects: true });

  return (
    <div className="container py-5">

      {/* Title */}
      <div className="text-center mb-5">
        <h2 className="fw-bold text-danger">{t('servicesPageTitle')}</h2>
        <p className="text-muted">
          {t('servicesPageSubtitle')}
        </p>
      </div>

      {/* Tabs */}
      {/* <ul className="nav nav-tabs justify-content-center mb-4">
        <li className="nav-item">
          <button className="nav-link active" data-bs-toggle="tab" data-bs-target="#activities">
            Key Activities
          </button>
        </li>
        <li className="nav-item">
          <button className="nav-link" data-bs-toggle="tab" data-bs-target="#objectives">
            Other Objectives
          </button>
        </li>
        <li className="nav-item">
          <button className="nav-link" data-bs-toggle="tab" data-bs-target="#services">
            Services Offered
          </button>
        </li>
        <li className="nav-item">
          <button className="nav-link" data-bs-toggle="tab" data-bs-target="#terms">
            General Terms
          </button>
        </li>
      </ul> */}

      <div className="container my-5">

        {/* ================= KEY ACTIVITIES ================= */}
        <div className="row align-items-center mb-5" >
          <div className="col-md-5 text-center" >
            <img
              data-aos="zoom-in-right"
              src={`${BASE_API}/images/services/img1.png`}
              alt="Key Activities"
              className="img-fluid rounded shadow"
            />
          </div>

          <div className="col-md-7" data-aos="fade-left">
                    <div className="section-card">
              <h4 className="section-title text-danger fw-bold mb-3">
                {t('servicesKeyActivitiesTitle')}
              </h4>
              <ul>
                {keyActivities.map((item, idx) => (
                  <li key={idx}>{item}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {/* ================= OTHER OBJECTIVES ================= */}
        <div className="row align-items-center mb-5">
          <div className="col-md-7 order-md-1 order-2" data-aos="fade-right">
            <div className="section-card">
              <h4 className="section-title text-danger fw-bold mb-3">
                {t('servicesOtherObjectivesTitle')}
              </h4>
              <ul>
                {otherObjectives.map((item, idx) => (
                  <li key={idx}>{item}</li>
                ))}
              </ul>
            </div>
          </div>

          <div className="col-md-5 text-center order-md-2 order-1">
            <img
              data-aos="zoom-in-left"
              src={`${BASE_API}/images/services/img2.png`}
              alt="Other Objectives"
              className="img-fluid rounded shadow"
            />
          </div>
        </div>

        {/* ================= SERVICES OFFERED ================= */}
        <div className="row align-items-center mb-5">
          <div className="col-md-5 text-center">
            <img
              data-aos="zoom-in-right"
              src={`${BASE_API}/images/services/img3.png`}
              alt={t('servicesOfferedTitle')}
              className="img-fluid rounded shadow"
            />
          </div>

          <div className="col-md-7" data-aos="fade-left">
            <div className="section-card">
              <h4 className="section-title text-danger fw-bold mb-3">
                {t('servicesOfferedTitle')}
              </h4>
              <ol>
                {servicesOffered.map((item, idx) => (
                  <li key={idx}>{item}</li>
                ))}
              </ol>
            </div>
          </div>
        </div>

        {/* ================= GENERAL TERMS ================= */}
        <div className="row mb-5">
          <div className="col-12">
            <div className="section-card">

              <h4 className="section-title text-danger fw-bold mb-4" data-aos="fade-left">
                {t('servicesGeneralTermsTitle')}
              </h4>

              {/* Responsive Columns */}
              <div className="row g-4" data-aos="fade-up">
                {generalTermsColumns.map((col, idx) => (
                  <div className="col-12 col-md-6 col-lg-3" key={idx}>
                    <h5 className="fw-bold text-primary">{col.title}</h5>
                    <ul>
                      {col.items.map((item, i) => (
                        <li key={i}>{item}</li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>

              {/* Tariff Table */}
              <h5 className="fw-bold mt-4 text-primary" data-aos="fade-left">
                {t('servicesTariffTitle')}
              </h5>

              <div className="table-responsive">
                <table className="table table-bordered table-striped" data-aos="fade-down">
                  <thead className="table-light">
                    <tr>
                      <th>{t('servicesTariffDuration')}</th>
                      <th>{t('servicesTariffRate')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {tariffRows.map((row, idx) => (
                      <tr key={idx}>
                        <td>{row.duration}</td>
                        <td>{row.rate}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default Services;